module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0016-1818f181cd50ab507d2102198ee81d7c.jpg";